
import {   GetJobRoleByID, UpdateJobRoleByID } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation,useNavigate} from "react-router-dom";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const EditJobRole = () => {
  let query = useQuery();
  const jobroleid = query.get("JobRole");
  const navigate=useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const[jobRoleid,setJobRoleid] = useState();
  const { selectedCountry} = useCountry();
const token = localStorage.getItem("jwtToken");
const GetVendorDetailsById = () => {
  const GetapiUrl = `${GetJobRoleByID.APIURL}?JobRoleID=${jobroleid}`;

  Axios.get(GetapiUrl, { headers: { Authorization: `Bearer ${token}` } })
    .then((result) => {
      setValue("jobRoleId",result.data[0].jobRoleId)
      setValue("jobRole",result.data[0].jobRole)

      setJobRoleid(result.data[0].jobRoleId)

    })
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    updateData(data);
  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }
  const updateData = async(data) => {
    const params={
      "jobRoleId": Number(jobroleid),
      "jobRole": data.jobRole,
      "countryID":selectedCountry
    }
 apiUrl = UpdateJobRoleByID.APIURL;
 Axios.post(apiUrl, params, {
   headers: {
     'Content-Type': 'application/json',
     'Authorization': `Bearer ${token}`,
   } })
   .then((result) => {
          if (result.data === 'Update successfully.') {
       // GetConsultantProfile();
     Swal.fire({
         position: 'center',
         icon: 'success',
         title: 'Updated Successfully ',
         showConfirmButton: false,
         timer: 5000
       })
       // toast.success('Data Saving', {autoClose:5000})
       navigate("/Employer/JobRoles")

     }
     else {
       // toast.error('Issue with data format', {autoClose:5000})
       Swal.fire({
         position: 'center',
         icon: 'error',
         title: 'Add correct Details',
         showConfirmButton: false,
         timer: 5000
       })
     }

   }).catch(
     function (error) {
       console.log("Error" + error)
     })

}



  useEffect(() => {
    GetVendorDetailsById();

  }, []);

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/JobRoles">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Job Role</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
<div className="row mt-2 p-0">
<div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
         
         <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Job Role</Tooltip>)}>
           <input type="text" name="jobRole"  {...register("jobRole", { required: "Role Name Required" })} placeholder="Job Role" className={`form-control basic-form  ${errors.jobRole ? 'is-invalid' : ''}`} />
         </OverlayTrigger>
         <div className="invalid-feedback"> {errors.jobRole?.message}</div>
      
       </div>
           

          </div>
         
          <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/JobRoles"> 
             <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Update
              </button> &nbsp;&nbsp;&nbsp;
            </div>
        </div>
        </form>
        </div></div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default EditJobRole;